import React, { useEffect, useState } from 'react';
import {
  Box, ImageListItem, Skeleton, Typography, Stack, Chip, CircularProgress, Button, ImageListItemBar, IconButton
} from '@mui/material';
import { useParams } from "react-router-dom";
import { db } from '../../lib/firebase';
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { doc, onSnapshot } from "firebase/firestore";
import { useUserTags } from '../../hooks/tags';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../lib/auth';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const SharedOutfit = () => {
  const { outfitId } = useParams();
  const { userId } = useParams();
  const [url, setUrl] = useState(null);
  const [outfit, setOutfit] = useState(null);
  const [userTags] = useUserTags(userId);
  const [userInfo, setUserInfo] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [logedUser] = useAuthState(auth)


  useEffect(() => {
    const userRef = doc(db, 'users', userId);

    onSnapshot(userRef, userDoc => {
      setUserInfo(userDoc.data());
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const outfitRef = doc(db, 'users', userId, 'outfits', outfitId);

    onSnapshot(outfitRef, outfitDoc => {
      setOutfit(outfitDoc.data());
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (outfit == null) return

    const storage = getStorage();
    getDownloadURL(ref(storage, `outfits/${outfit.coverPhoto}_900x1200`)).then((downloadURL) => {
      setUrl(downloadURL);
    })
  }, [outfit]);


  const getOutfitTagsWithName = () => {
    if (userTags == null) return [];
    if (outfit == null) return

    const outfitTagsIds = outfit.moments

    return userTags.filter((tag) => outfitTagsIds.includes(tag.id))
  }

  const handleCreateAnAccount = () => {
    navigate("/");
  }

  const handleGoHome = () => {
    navigate("/");
  };

  if (outfitId == null || userId == null || outfit == null) {
    return <><CircularProgress /></>
  }

  return (
    <Box>
      <ImageListItem key={url} sx={{ mb: 1 }}>
        {url ? (
          <img
            src={`${url}?w=248&fit=crop&auto=format`}
            srcSet={`${url}?w=248&fit=crop&auto=format&dpr=2 2x`}
            alt={'mau'}
            loading="lazy"
            style={{ width: "100%" }}
          />
        ) : (
          <Skeleton variant="rectangular" animation="wave" height={'100%'} />
        )}

        {logedUser && <ImageListItemBar
          sx={{
            background:
              'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
              'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
          }}
          position="top"
          actionIcon={
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100vw' }}>
              <IconButton
                sx={{ color: 'white' }}
                onClick={handleGoHome}
              >
                <ArrowBackIosIcon />
              </IconButton>
            </Box>
          }
          actionPosition="left"
        />
        }
      </ImageListItem>

      <Box sx={{ textAlign: 'center', letterSpacing: 6 }}>
        {userInfo.userName} Outfit
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', mb: 3 }}>
        <Box sx={{ letterSpacing: 6, mb: 2 }}>
          Tags:
        </Box>
        <Stack direction="row" spacing={1} sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          {getOutfitTagsWithName().map((tag) => (
            <Chip
              label={tag.name} sx={{ mb: 1, mt: 1 }}
              key={tag.id}
            />
          ))}
        </Stack>
      </Box>
      {!logedUser && <Box sx={{ textAlign: 'center' }}>
        <Button onClick={handleCreateAnAccount} variant="outlined">{t('sharedOutfit.createAnAccount')}</Button>
      </Box>}
    </Box>
  )
};

export default SharedOutfit;